import React from 'react';
import {
  Box,
  Container,
  Typography,
  Link,
  Grid,
  Paper,
  Divider
} from '@mui/material';
import { Phone, Email } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import constants from '../../constants';
import logo from '../../images/ontraq_healthfirst.png';
import theme from '../../themes/theme';

const Support = () => {
  const navigate = useNavigate();

  const handleAddCustomer = () => {
    window.location.href = constants.LOGIN_URL;
  };

  return (
    <Box sx={{
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Box
        sx={{
          display: 'flex',
          backgroundColor: theme.palette.primary.main,
          minHeight: '50px',
          alignItems: 'center',
        }}
      >
        <Link 
          component="button" 
          onClick={() => navigate('/')} 
          sx={{ ml: 2, textDecoration: 'none' }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={logo}
              alt="OnTraq HealthFirst"
              style={{ width: '150px' }}
            />
          </Box>
        </Link>
      </Box>
      <Container maxWidth="md" sx={{
        py: 8,
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <Paper
          elevation={2}
          sx={{
            p: 6,
            textAlign: 'center',
            borderRadius: 2,
            width: '100%',
            maxWidth: '600px'
          }}
        >
          <Typography
            variant="h3"
            component="h1"
            sx={{
              mb: 4,
              fontWeight: 300,
              color: theme.palette.primary.main
            }}
          >
            No Practice Found
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mb: 4,
              fontSize: '1.1rem',
              lineHeight: 1.6,
              color: 'text.secondary'
            }}
          >
            We are sorry, we did not find a customer account with your login. OnTraq is complimentary for registered
            customers. If you are an existing customer or would like to make a purchase,{' '}
            <Link
              component="button"
              variant="body1"
              onClick={handleAddCustomer}
              sx={{
                color: 'primary.main',
              }}
            >
              click here
            </Link>
            {' '}to add your practice, or call us at{' '}
            <Link
              href={`tel:${constants.HEALTHFIRST_PHONE_NUMBER}`}
              sx={{ color: 'primary.main' }}
            >
              {constants.HEALTHFIRST_PHONE_NUMBER}
            </Link>.
          </Typography>
        </Paper>
      </Container>
      <Box
        sx={{
          backgroundColor: 'white',
          borderTop: '1px solid #e0e0e0',
          py: 2,
          mt: 'auto'
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={3} justifyContent="center">
            <Grid item xs={12} sx={{ textAlign: 'center' }}>
              <Link
                component="button"
                onClick={() => navigate('/terms')}
                sx={{
                  mx: 2,
                  color: 'text.secondary',
                  textDecoration: 'none',
                  '&:hover': { color: 'primary.main' }
                }}
              >
                Privacy
              </Link>
              <Link
                href={constants.CUSTOMER_SUPPORT_URL}
                target="_blank"
                sx={{
                  mx: 2,
                  color: 'text.secondary',
                  textDecoration: 'none',
                  '&:hover': { color: 'primary.main' }
                }}
              >
                Contact Us
              </Link>
            </Grid>
            <Grid item xs={12} sx={{ textAlign: 'center' }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mx: 2 }}>
                  <Phone sx={{ mr: 1, color: 'text.secondary' }} />
                  <Link
                    href={`tel:${constants.HEALTHFIRST_PHONE_NUMBER}`}
                    sx={{
                      color: 'text.secondary',
                      textDecoration: 'none',
                      '&:hover': { color: 'primary.main' }
                    }}
                  >
                    {constants.HEALTHFIRST_PHONE_NUMBER}
                  </Link>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', mx: 2 }}>
                  <Email sx={{ mr: 1, color: 'text.secondary' }} />
                  <Link
                    href={`mailto:${constants.CUSTOMER_SERVICE_EMAIL}?Subject=Questions%20about%20OnTraq`}
                    sx={{
                      color: 'text.secondary',
                      textDecoration: 'none',
                      '&:hover': { color: 'primary.main' }
                    }}
                  >
                    {constants.CUSTOMER_SERVICE_EMAIL}
                  </Link>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default Support;
